"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHydrogenPowerCar = function IconHydrogenPowerCar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m24.427 11.427-1.414-1.414-5.15 5.15-.136.145a3 3 0 0 0 .136 4.1l5.3 5.3.814-.814-.823.824.114.124a1.91 1.91 0 0 1-.114 2.58 1.91 1.91 0 0 1-2.706.002l-.86.859.859-.86L15 21.976V16l-.005-.217A5 5 0 0 0 10 11H6v2h4l.176.005A3 3 0 0 1 13 16v27h2V24.804l4.033 4.033.16.152a3.91 3.91 0 0 0 5.375-.152 3.91 3.91 0 0 0 0-5.534l.01-.01-3.988-3.987a3.5 3.5 0 0 0 .774-4.816zm-3.467 5.514a2.5 2.5 0 0 1-1.087 1.648l-.596-.596-.087-.1a1 1 0 0 1 .087-1.315l1.365-1.366a2.5 2.5 0 0 1 .318 1.729m14.023 9.89-8.063-7.685-1.38 1.448 8.515 8.115 9.218 1.468.123.028a1.11 1.11 0 0 1 .79 1.266l-.86 4.626-.028.118a1.11 1.11 0 0 1-1.06.785H38.9a5.002 5.002 0 0 0-9.8 0H18v2h11.1a5.002 5.002 0 0 0 9.8 0h3.34l.186-.006a3.11 3.11 0 0 0 2.867-2.53l.86-4.631.03-.207a3.1 3.1 0 0 0-.55-2.149l-.126-.166a3.1 3.1 0 0 0-1.918-1.108zM34 35a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M26 36v-1h-4v1zM7.745 22v5.654H6.718v-2.481H4.036v2.482H3V22h1.036v2.19h2.682V22zm.819 7.073 1.054-.91.02-.017c.184-.167.371-.335.371-.555a.255.255 0 0 0-.282-.264.31.31 0 0 0-.327.346h-.91a1.1 1.1 0 0 1 1.265-1.191c.763 0 1.209.382 1.209.99-.02.432-.247.828-.61 1.064L9.8 29H11v.827H8.564z",
    clipRule: "evenodd"
  })));
};

export { IconHydrogenPowerCar, IconHydrogenPowerCar as default };
